/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
import React, {
  useState, useRef, useLayoutEffect,memo
} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ModifiersNewUI from '@components/modifiersNewUI';
import Loader from '@components/common/Loader/index';
import cn from 'classnames';
import style from './modifiers.module.scss';
import groupBy from 'lodash/groupBy';
import filter from 'lodash/filter';
import find from 'lodash/find';
import {
  pushModifierToItem,
  toggleNestedModifierFlag,
  pushModifiersGroupData,
  pushNestedModifierToItem,
  pushModifierToCount,
  removeModifiers,
  updateModifierToItemPromise,
  appendModifiersToList,
  updateCollapsedModifierArray,
  setFunctionModifierId,
  setGlobalModStatus,
  setSelectedModifierPath,
  editModifiers,
  getSyncModifierData
} from '@reducers/orders';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import { setNotification } from '@reducers/notification';
import { APP_CONFIG, ERROR_MESSAGE } from '@constants';
import { updateHeaderData, toggleCancelButtonSamePage } from '@reducers/header';
import { LABEL } from '../../veriables';
import { flowType } from '../../utility/userInfo';

const renderModifierData = (showEdit, modifierGroupsHashTable, modifiergroupList, modifiersHashTable, onClickModifier, onClickAddModifier, modifierData, nestedModifierArray, themeStyle, onClickModifierCounter, onClickNegitiveModifierCounter, setPrevModifier, itemInfo, onSlideChange, pushNestedModifierCounter, activeMenuItemId, menuItemsHashTable, isNestedModifier, updateCollapsedModifier, collapsedModifierArray, isOrderAnother, menuItemId, auth, menusList, menuIndex, modifierNote, handleNote, handleGlobalModFunction) => {
  return modifiergroupList?.map((modifierGroup) => ((modifierGroupsHashTable[modifierGroup.modifierGroupId]?.hiddenMenuId !== activeMenuItemId)) && (
    <ModifiersNewUI
      key={modifierGroup.id}
      showEdit={showEdit}
      modifierGroupsHashTable={modifierGroupsHashTable}
      modifierGroup={modifierGroup}
      modifiersHashTable={modifiersHashTable}
      onClickModifier={onClickModifier}
      onClickAddModifier={onClickAddModifier}
      modifierData={modifierData}
      nestedModifierArray={nestedModifierArray}
      themeStyle={themeStyle}
      onClickModifierCounter={onClickModifierCounter}
      onClickNegitiveModifierCounter={onClickNegitiveModifierCounter}
      setPrevModifier={setPrevModifier}
      itemInfo={itemInfo}
      onSlideChange={onSlideChange}
      pushNestedModifierCounter={pushNestedModifierCounter}
      menuItemsHashTable={menuItemsHashTable}
      isNestedModifier={isNestedModifier}
      updateCollapsedModifier={updateCollapsedModifier}
      collapsedModifierArray={collapsedModifierArray}
      isOrderAnother={isOrderAnother}
      menuItemId={menuItemId}
      auth={auth}
      menusList={menusList}
      menuIndex={menuIndex}
      modifierNote={modifierNote}
      handleNote={handleNote}
      handleGlobalModFunction={handleGlobalModFunction}
    />
  ));
};

const Modifier = (props) => {

  // Props Destructuring

  const {
    modifierLevelData,
    modifiersHashTable,
    modifierData,
    modifierGroupsHashTable,
    themeStyle,
    itemInfo,
    isOrderAnother,
    modifierNote,
    handleNote,
    modifierEditData,
    setSelectedModifierPath,
    cancelOnPage,
    isNestedModifier,
    toggleCancelButtonSamePage,
    handleScroll,
    toggleNestedModifierFlag,
    appendModifiersToList,
    activeMenuItemId,
    pushModifiersGroupData,
    removeModifiers,
    pushModifierToItem,
    functionModifierId,
    setFunctionModifierId,
    onChangeModifier,
    menusList,
    menuIndex,
    pushModifierToCount,
    menuItemsHashTable,
    setNotification,
    updateModifierToItemPromise,
    updateCollapsedModifierArray,
    collapsedModifierArray,
    auth,
    userInfo,
    editModifiers
  } = props;
  
  // State Management

  let [nestedModifierArray, setNestedModifierArray] = useState([]);
  const isKiosk = flowType() === 'kiosk';
  const [tempModifier, setTempModifier] = useState([]);
  const [prevModifier, setPrevModifier] = useState([]);
  const [addBoolean, setAddBoolean] = useState(false);
  const [lastEle, setLastEle] = useState('');
  const [isScroll, setScroll] = useState(false);
  const [addModifierBool, setAddModifierBool] = useState(false);
  const nestModId = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('nestModId')), null);
  const [isSubNestModifier, setIsSubNestModifier] = useState(false);
  const subModRef = useRef(null);

  // React Hooks

  useLayoutEffect(() => {
    if (modifierEditData) {
      onClickModifier(modifierEditData.modifier, modifierEditData.modifierGroupId, '', 'edit');
    } else if (modifierEditData && Object.keys(modifierEditData).length > 0) {
      onNestedBack(true);
    }
    setSelectedModifierPath('');
  }, [modifierEditData]);
   
  useLayoutEffect(() => {
    if (cancelOnPage && isNestedModifier) {
      onNestedBack(false);
      toggleCancelButtonSamePage(false);
    } else if (cancelOnPage) {
      props.history.replace(`${APP_CONFIG.BASE_URL}/orders`);
    }
  }, [cancelOnPage]);

  useLayoutEffect(() => {
    if (isNestedModifier || isSubNestModifier) {
      if (subModRef && subModRef.current) {
        subModRef.current.scrollIntoView({
          behavior: 'instant',
          block: 'start',
        });
        setIsSubNestModifier(false);
      }
    } else {
      if (isScroll && nestModId) {
        let scrollId = nestModId;
        if (JSON.parse(window.sessionStorage.getItem('modGroup')) && JSON.parse(window.sessionStorage.getItem('modGroup')).maximum === 1) {
          scrollId = JSON.parse(window.sessionStorage.getItem('modGroup')).id;
        }
        handleScroll(scrollId);
      }
      window.sessionStorage.removeItem('nestModId');
    }
  }, [isNestedModifier, isSubNestModifier]);

  // Methods

  const getPath = (data, dataToAppend) => {
    const arrayData = [...data];
    if (dataToAppend) {
      arrayData.push(dataToAppend);
    }
    return arrayData.join('|');
  };

  const showEdit = (modifier) => {
    const modifierList = modifiersHashTable[modifier].modifierGroupLinks.map((item) => ({
      ...item,
      ...modifierGroupsHashTable[item.modifierGroupId]
    }));
    return modifierList.length > 0;
  };

  const onClickAddModifier = (modifier, modifierGroup, isActive, key) => {
    setSelectedModifierPath('');
    const modifierDataToPush = `${modifier}-${modifierGroup}`;
    const modifierList = modifiersHashTable[modifier].modifierGroupLinks.map((item) => ({
      ...item,
      ...modifierGroupsHashTable[item.modifierGroupId]
    }));

    if ((isKiosk || key === 'edit' || modifierList.filter((e) => e.minimum > 0).length > 0 || modifierList.filter((e) => e.flowRequired).length > 0) && modifiersHashTable[modifier].modifierGroupLinks.length > 0) {
      setAddBoolean(true);
      toggleNestedModifierFlag(true);
      setIsSubNestModifier(true);
      let newArr = prevModifier;
      if (newArr.length > 0 && newArr[newArr.length - 1] !== modifierDataToPush) {
        newArr.push(`${modifierDataToPush}`);
      }
      nestedModifierArray.push(`${modifierDataToPush}`);
      setNestedModifierArray(newArr);
      setTempModifier(modifierData);
      setPrevModifier([...prevModifier, modifierDataToPush]);
      const preSelectModList = [];
      modifiersHashTable[modifier].modifierGroupLinks.forEach((item) => {
        if (modifierGroupsHashTable[item.modifierGroupId].hiddenMenuId === activeMenuItemId && modifierGroupsHashTable[item.modifierGroupId].hiddenAutoAddModifierId) {
          preSelectModList.push(`${modifierDataToPush ? `${modifierDataToPush}|` : ''}${modifierGroupsHashTable[item.modifierGroupId].hiddenAutoAddModifierId}-${item.modifierGroupId}`);
        } else {
          modifierGroupsHashTable[item.modifierGroupId].modifierLinks.forEach((nMod) => {
            if (nMod.included) {
              preSelectModList.push(`${modifierDataToPush}|${nMod.modifierId}-${modifierGroupsHashTable[item.modifierGroupId].id}`);
            }
          });
        }
      });
      if (filter(modifierData, (d) => d?.startsWith(modifierDataToPush))?.length === 0) {
        appendModifiersToList(preSelectModList);
      }
      window.scrollTo(0, 0);
      pushModifiersGroupData(modifierList, 'isNested');
      if (newArr.length === 0) {
        setAddModifierBool(true);
      }
    } else if (nestedModifierArray.length === 0) {
      if (modifierGroupsHashTable[modifierGroup].maximum === 1 && !isActive) {
        const modifiersToRemove = [];
        if (modifierGroupsHashTable[modifierGroup].modifierLinks.length === 0) {
          modifierGroupsHashTable[modifierGroup].modifierLinks.forEach((d) => {
            if (modifierData.includes(`${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)) {
              modifiersToRemove.push(`${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`);
            }
          });
        } else {
          modifierGroupsHashTable[modifierGroup].modifierLinks.forEach((d) => {
            modifierData.filter((e) => e).forEach((modData) => {
              if (modData?.startsWith(`${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)) {
                modifiersToRemove.push(modData);
              }
            });
          });
        }
        if (modifiersToRemove.length > 0) {
          removeModifiers(modifiersToRemove);
        }
      }
      pushModifierToItem(modifierDataToPush);
    } else {
      if (modifierGroupsHashTable[modifierGroup].maximum === 1) {
        const modifiersToRemove = [];
        modifierGroupsHashTable[modifierGroup].modifierLinks.forEach((d) => {
          if (modifierData.includes(`${getPath(nestedModifierArray, `${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)}`)) {
            modifiersToRemove.push(`${getPath(nestedModifierArray, `${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)}`);
          }
        });
        if (modifiersToRemove.length > 0) {
          removeModifiers(modifiersToRemove);
        }
      }
      pushModifierToItem(`${getPath(nestedModifierArray, `${modifierDataToPush}`)}`);
    }
    if (functionModifierId) {
      if (modifiersHashTable[modifier].modifierGroupLinks.length > 0 || isActive) {
        setFunctionModifierId(null);
      } else {
        let functionModifierPath = '';
        if (nestedModifierArray.length > 0 && !(modifierData.includes(`${getPath(nestedModifierArray, `${modifierDataToPush}`)}|${functionModifierId}-${menusList[menuIndex].modFunctionModifierGroupId}`))) {
          functionModifierPath = `${getPath(nestedModifierArray, `${modifierDataToPush}`)}|${functionModifierId}-${menusList[menuIndex].modFunctionModifierGroupId}`;
        } else {
          functionModifierPath = `${modifierDataToPush}|${functionModifierId}-${menusList[menuIndex].modFunctionModifierGroupId}`;
        }
        pushModifierToItem(functionModifierPath);
        setFunctionModifierId(null);
      }
    }
    if (!isKiosk) {
      onChangeModifier(getSyncModifierData());
    }
  };

  const onClickModifierCounter = (modifier, modifierGroup, isInc) => {
    const modifierDataToPush = `${modifier}-${modifierGroup}`;
    if (nestedModifierArray.length === 0) {
      pushModifierToCount(modifierDataToPush, isInc);
    } else {
      pushModifierToCount(`${getPath(nestedModifierArray, `${modifierDataToPush}`)}`, isInc);
    }
  };


  const onClickModifier = (modifier, modifierGroup, isActive, key) => {
    setSelectedModifierPath('');
    const modifierDataToPush = `${modifier}-${modifierGroup}`;
    const modifierList = modifiersHashTable[modifier].modifierGroupLinks.map((item) => ({
      ...item,
      ...modifierGroupsHashTable[item.modifierGroupId]
    }));
    if ((isKiosk || key === 'edit' || modifierList.filter((e) => e.minimum > 0).length > 0 || modifierList.filter((e) => e.flowRequired).length > 0) && modifiersHashTable[modifier].modifierGroupLinks.length > 0) {
      toggleNestedModifierFlag(true);
      setIsSubNestModifier(true);
      nestedModifierArray.push(`${modifierDataToPush}`);
      setNestedModifierArray(nestedModifierArray);
      setTempModifier(modifierData);
      const preSelectModList = [];
      modifiersHashTable[modifier].modifierGroupLinks.forEach((item) => {
        if (modifierGroupsHashTable[item.modifierGroupId].hiddenMenuId === activeMenuItemId && modifierGroupsHashTable[item.modifierGroupId].hiddenAutoAddModifierId) {
          preSelectModList.push(`${modifierDataToPush ? `${modifierDataToPush}|` : ''}${modifierGroupsHashTable[item.modifierGroupId].hiddenAutoAddModifierId}-${item.modifierGroupId}`);
        } else {
          modifierGroupsHashTable[item.modifierGroupId].modifierLinks.forEach((nMod) => {
            if (nMod.included) {
              preSelectModList.push(`${modifierDataToPush}|${nMod.modifierId}-${modifierGroupsHashTable[item.modifierGroupId].id}`);
            }
          });
        }
      });
      if (filter(modifierData, (d) => d?.startsWith(modifierDataToPush)).length === 0) {
        appendModifiersToList(preSelectModList);
      }
      window.scrollTo(0, 0);
      pushModifiersGroupData(modifierList, 'isNested');
    } else if (nestedModifierArray.length === 0 && !addModifierBool) {
      if (modifierGroupsHashTable[modifierGroup].maximum === 1 && !isActive) {
        const modifiersToRemove = [];
        if (modifierGroupsHashTable[modifierGroup].modifierLinks.length === 0) {
          modifierGroupsHashTable[modifierGroup].modifierLinks.forEach((d) => {
            if (modifierData.includes(`${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)) {
              modifiersToRemove.push(`${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`);
            }
          });
        } else {
          modifierGroupsHashTable[modifierGroup].modifierLinks.forEach((d) => {
            modifierData.filter((e) => e).forEach((modData) => {
              if (modData?.startsWith(`${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)) {
                modifiersToRemove.push(modData);
              }
            });
          });
        }
        if (modifiersToRemove.length > 0) {
          removeModifiers(modifiersToRemove);
        }
      }
      pushModifierToItem(modifierDataToPush);
    } else {
      let isWeightedVal = true
      if (nestedModifierArray.length === 0 && addModifierBool) {
        nestedModifierArray = modifierData;
        nestedModifierArray.push(`${modifierDataToPush}`);
      }
      if (nestedModifierArray.length > 0) { 
        if (nestedModifierArray[nestedModifierArray.length - 1]?.includes('|')) {
          const newEle = nestedModifierArray[0]?.split('|')[0];
          const newEle1 = newEle.split('-')[1];
          if (modifierGroupsHashTable[newEle1]?.isWeight === false){
            isWeightedVal = false
          }
        } else if (nestedModifierArray.length > 0) {
          const newEle1 = nestedModifierArray[nestedModifierArray - 1]?.split('-')[1];
          if (modifierGroupsHashTable[newEle1]?.isWeight === false){
            isWeightedVal = false
          }
        }
       }
      if (isWeightedVal && addBoolean) {
        setTempModifier(modifierData);
        const modifiersToRemove = [];
        modifierGroupsHashTable[modifierGroup].modifierLinks.forEach((d) => {
          if (modifierData.includes(`${getPath(nestedModifierArray, `${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)}`)) {
            modifiersToRemove.push(`${getPath(nestedModifierArray, `${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)}`);
            modifiersToRemove.push(`${getPath(nestedModifierArray)}`);
          }
        });
        if (modifiersToRemove.length > 0) {
          modifiersToRemove.pop();
          removeModifiers(modifiersToRemove);
        }
        let val = '';
        if (nestedModifierArray[nestedModifierArray.length - 1] !== undefined && nestedModifierArray[nestedModifierArray.length - 1].includes('|')) {
          const nesindex = nestedModifierArray[nestedModifierArray.length - 1].split('|');
          val = nesindex[0];
          nestedModifierArray[nestedModifierArray.length - 1] = val;
        }
        if (nestedModifierArray.length > 1) {
          nestedModifierArray = [nestedModifierArray[nestedModifierArray.length - 1]];
          setNestedModifierArray(nestedModifierArray);
        }
        setLastEle(nestedModifierArray[nestedModifierArray.length - 1]);
        setAddBoolean(true);
        pushModifierToCount(`${getPath(nestedModifierArray, `${modifierDataToPush}`)}`, true);
        if (functionModifierId) {
          if (modifiersHashTable[modifier].modifierGroupLinks.length > 0 || isActive) {
            setFunctionModifierId(null);
          } else {
            let functionModifierPath = '';
            if (nestedModifierArray.length > 0 && !(modifierData.includes(`${getPath(nestedModifierArray, `${modifierDataToPush}`)}|${functionModifierId}-${menusList[menuIndex].modFunctionModifierGroupId}`))) {
              functionModifierPath = `${getPath(nestedModifierArray, `${modifierDataToPush}`)}|${functionModifierId}-${menusList[menuIndex].modFunctionModifierGroupId}`;
            } else {
              functionModifierPath = `${modifierDataToPush}|${functionModifierId}-${menusList[menuIndex].modFunctionModifierGroupId}`;
            }
            pushModifierToItem(functionModifierPath);
            setFunctionModifierId(null);
          }
        }
        if (!isKiosk) {
          onChangeModifier(getSyncModifierData());
        }
        return
      } else if (modifierGroupsHashTable[modifierGroup].maximum === 1) {
        const modifiersToRemove = [];
        modifierGroupsHashTable[modifierGroup].modifierLinks.forEach((d) => {
          if (modifierData.includes(`${getPath(nestedModifierArray, `${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)}`)) {
            modifiersToRemove.push(`${getPath(nestedModifierArray, `${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)}`);
            if (!nestedModifierArray.includes('|')) {
              if (modifierGroupsHashTable[nestedModifierArray[0].split('-')[1]].isWeight) {
                modifiersToRemove.push(`${getPath(nestedModifierArray)}`)
              }
            }
          }
        });
        if (modifiersToRemove.length > 0) {
          removeModifiers(modifiersToRemove);
        }

        pushModifierToItem(`${getPath(nestedModifierArray, `${modifierDataToPush}`)}`);
        setAddModifierBool(false);
      } else {
        if (modifierGroupsHashTable[modifierGroup].maximum === 1) {
          const modifiersToRemove = [];
          modifierGroupsHashTable[modifierGroup].modifierLinks.forEach((d) => {
            if (modifierData.includes(`${getPath(nestedModifierArray, `${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)}`)) {
              modifiersToRemove.push(`${getPath(nestedModifierArray, `${d.modifierId}-${modifierGroupsHashTable[modifierGroup].id}`)}`);
            }
          });
          if (modifiersToRemove.length > 0) {
            removeModifiers(modifiersToRemove);
          }
        }
        pushModifierToItem(`${getPath(nestedModifierArray, `${modifierDataToPush}`)}`);
        setAddModifierBool(false);
      }
    }
    if (functionModifierId) {
      if (modifiersHashTable[modifier].modifierGroupLinks.length > 0 || isActive) {
        setFunctionModifierId(null);
      } else {
        let functionModifierPath = '';
        if (nestedModifierArray.length > 0 && !(modifierData.includes(`${getPath(nestedModifierArray, `${modifierDataToPush}`)}|${functionModifierId}-${menusList[menuIndex].modFunctionModifierGroupId}`))) {
          functionModifierPath = `${getPath(nestedModifierArray, `${modifierDataToPush}`)}|${functionModifierId}-${menusList[menuIndex].modFunctionModifierGroupId}`;
        } else {
          functionModifierPath = `${modifierDataToPush}|${functionModifierId}-${menusList[menuIndex].modFunctionModifierGroupId}`;
        }
        pushModifierToItem(functionModifierPath);
        setFunctionModifierId(null);
      }
    }
    if (!isKiosk) {
      onChangeModifier(getSyncModifierData());
    }
  };

  const onClickNegitiveModifierCounter = (modifier, modifierGroup, isInc) => {
    const modifierDataToPush = `${modifier}-${modifierGroup}`;
    if (nestedModifierArray.length === 0) {
      let count = 0;
      modifierData.forEach((element) => {
        if (element === modifierDataToPush) {
          count += 1;
        }
      });
      if (count > 1) {
        const newModList = [...modifierData];
        const foundIdx = newModList.lastIndexOf(modifierDataToPush);

        pushModifierToCount(modifierDataToPush, isInc, 'removeLast');
        pushModifierToCount(newModList[foundIdx - 1], isInc);
        const newPropsData = [...newModList];
        newPropsData.splice(foundIdx, 1); // 2nd parameter means remove one item only
        // }
        const index = newPropsData.lastIndexOf(modifierData[foundIdx - 1]);
        if (index > -1) { // only splice array when item is found
          newPropsData.splice(index, 1); // 2nd parameter means remove one item only
        }
        setPrevModifier(newPropsData);
      } else {
        pushModifierToCount(modifierDataToPush, isInc);
        setPrevModifier((todos) => todos.filter((item, i) => item != modifierDataToPush));
      }
    } else {
      pushModifierToCount(`${getPath(nestedModifierArray, `${modifierDataToPush}`)}`, isInc);
    }
  };
  const onNestedBack = (isSave, isDelete, updatedModifierData, nesMod, addboolFalse) => {
    if (nesMod?.length > 0) {
      pushModifierToItem(updatedModifierData);
      nestedModifierArray = nesMod;
      nestedModifierArray.pop();
      setNestedModifierArray(nestedModifierArray);
      setAddBoolean(!addBoolean);
      if (nestedModifierArray.length === 0) {
        const modifierList = menuItemsHashTable[props.match.params.menuItemId].modifierGroupLinks.map((item) => ({
          ...item,
          ...modifierGroupsHashTable[item.modifierGroupId]
        }));
        pushModifiersGroupData(modifierList, 'isNested');
        toggleNestedModifierFlag(false);
        setIsSubNestModifier(false);
      }
    }
    if (addBoolean && !isDelete) {
      const newArray = [];
      modifierData.forEach((modifier) => {
        if (modifier?.startsWith(getPath(nestedModifierArray)) && modifier.includes('|')) {
          if (modifier?.replace(getPath(nestedModifierArray), '')) {
            newArray.push(modifier?.replace(getPath(nestedModifierArray), ''));
          }
        }
      });
      const requiredModifierList = [];
      modifierLevelData.forEach((item) => {
        if (modifierGroupsHashTable[item.modifierGroupId].minimum > 0 && (modifierGroupsHashTable[item.modifierGroupId].hiddenMenuId !== activeMenuItemId)) {
          requiredModifierList.push({
            ...item,
            modifierGroupId: item.modifierGroupId,
            minimum: modifierGroupsHashTable[item.modifierGroupId].minimum
          });
        }
      });
      const modifierListGroupById = groupBy(newArray, (d) => d.split('-')[1].split('|')[0]);
      for (let i = 0; i < requiredModifierList.length; i += 1) {
        if ((modifierListGroupById[requiredModifierList[i].modifierGroupId] || []).length < requiredModifierList[i].minimum) {
          setNotification({
            type: 'danger',
            message: ERROR_MESSAGE.SELECT_REQUIRED_MODIFIERS
          });
          return;
        }
      }
      if (filter(filter([...modifierData], (d) => d?.startsWith(nestedModifierArray[0])), (d) => d.includes('|')).length > 0 && find(modifierData, (d) => d === nestedModifierArray[0])) {
        if (!modifierData.includes(nestedModifierArray[0])) {
          pushModifierToItem(nestedModifierArray[0]);
        }
      } else if (modifierGroupsHashTable[(nestedModifierArray[0] || '').split('-')[1]]?.maximum === 1) {
        const removeList = filter(tempModifier, (d) => {
          return (d?.split('|')[0].split('-')[1] === nestedModifierArray[0].split('-')[1] && !d?.startsWith(nestedModifierArray[0]));
        });
        if (removeList.length > 0) {
          removeModifiers(removeList);
        }
      }
      // added for bug fix for 3rd level - should work on this
      if (nestedModifierArray[1] && modifierGroupsHashTable[nestedModifierArray[1].split('-').reverse()[0]].maximum === 1) {
        removeModifiers(tempModifier.filter((d) => d.indexOf(`-${nestedModifierArray[1].split('-').reverse()[0]}`) !== -1 && d !== `${nestedModifierArray[0]}|${nestedModifierArray[1]}`));
      }
      // added for bug fix for 3rd level - should work on this
      if (nestedModifierArray[1] && !modifierData.includes(nestedModifierArray[1]) && modifierData.filter((d) => d?.startsWith(`${nestedModifierArray[0]}|${nestedModifierArray[1]}`)).length === 0) {
        pushModifierToItem(`${nestedModifierArray[0]}|${nestedModifierArray[1]}`);
      }
      if (nestedModifierArray[2] && !modifierData.includes(nestedModifierArray[2]) && modifierData.filter((d) => d?.startsWith(`${nestedModifierArray[0]}|${nestedModifierArray[1]}|${nestedModifierArray[2]}`)).length === 0) {
        pushModifierToItem(`${nestedModifierArray[0]}|${nestedModifierArray[1]}|${nestedModifierArray[2]}`);
      }
      pushModifierToCount(nestedModifierArray[0], true);
      setNestedModifierArray(nestedModifierArray);
      if (nestedModifierArray.length === 0) {
        const modifierList = menuItemsHashTable[props.match.params.menuItemId].modifierGroupLinks.map((item) => ({
          ...item,
          ...modifierGroupsHashTable[item.modifierGroupId]
        }));
        pushModifiersGroupData(modifierList, 'isNested');
        toggleNestedModifierFlag(false);
        setIsSubNestModifier(false);
      } else {
        const menuItemId = nestedModifierArray[nestedModifierArray.length - 1].split('|').filter((el) => {
          return el !== '';
        }).slice(-1)[0].split('-')[0];
        const modifierList = modifiersHashTable[menuItemId].modifierGroupLinks.map((item) => ({
          ...item,
          ...modifierGroupsHashTable[item.modifierGroupId]
        }));
        pushModifiersGroupData(modifierList, 'isNested');
      }
      setAddBoolean(false);
      return;
    }
    if (isSave) {
      const newArray = [];
      modifierData.forEach((modifier) => {
        if (modifier?.startsWith(getPath(nestedModifierArray)) && modifier.includes('|')) {
          if (modifier?.replace(getPath(nestedModifierArray), '')) {
            newArray.push(modifier?.replace(getPath(nestedModifierArray), ''));
          }
        }
      });
      const requiredModifierList = [];
      modifierLevelData.forEach((item) => {
        if (modifierGroupsHashTable[item.modifierGroupId].minimum > 0 && (modifierGroupsHashTable[item.modifierGroupId].hiddenMenuId !== activeMenuItemId)) {
          requiredModifierList.push({
            ...item,
            modifierGroupId: item.modifierGroupId,
            minimum: modifierGroupsHashTable[item.modifierGroupId].minimum
          });
        }
      });
      const modifierListGroupById = groupBy(newArray, (d) => d.split('-')[1].split('|')[0]);
      for (let i = 0; i < requiredModifierList.length; i += 1) {
        if ((modifierListGroupById[requiredModifierList[i].modifierGroupId] || []).length < requiredModifierList[i].minimum) {
          setNotification({
            type: 'danger',
            message: ERROR_MESSAGE.SELECT_REQUIRED_MODIFIERS
          });
          return;
        }
      }
      if (filter(filter([...modifierData], (d) => d?.startsWith(nestedModifierArray[0])), (d) => d.includes('|')).length > 0 && find(modifierData, (d) => d === nestedModifierArray[0])) {
        if (!modifierData.includes(nestedModifierArray[0])) {
          pushModifierToItem(nestedModifierArray[0]);
        } 
      } else if (modifierGroupsHashTable[nestedModifierArray[0].split('-')[1]].maximum === 1) {
        const removeList = filter(tempModifier, (d) => {
          return (d.split('|')[0].split('-')[1] === nestedModifierArray[0].split('-')[1] && !d?.startsWith(nestedModifierArray[0]));
        });
        if (removeList.length > 0) {
          removeModifiers(removeList);
        }
      } 
      // added for bug fix for 3rd level - should work on this
      if (nestedModifierArray[1] && modifierGroupsHashTable[nestedModifierArray[1].split('-').reverse()[0]].maximum === 1) {
        removeModifiers(tempModifier.filter((d) => d.indexOf(`-${nestedModifierArray[1].split('-').reverse()[0]}`) !== -1 && d !== `${nestedModifierArray[0]}|${nestedModifierArray[1]}`));
      }
      // added for bug fix for 3rd level - should work on this
      if (nestedModifierArray[1] && !modifierData.includes(nestedModifierArray[1]) && modifierData.filter((d) => d?.startsWith(`${nestedModifierArray[0]}|${nestedModifierArray[1]}`)).length === 0) {
        pushModifierToItem(`${nestedModifierArray[0]}|${nestedModifierArray[1]}`);
      }
      if (nestedModifierArray[2] && !modifierData.includes(nestedModifierArray[2]) && modifierData.filter((d) => d?.startsWith(`${nestedModifierArray[0]}|${nestedModifierArray[1]}|${nestedModifierArray[2]}`)).length === 0) {
        pushModifierToItem(`${nestedModifierArray[0]}|${nestedModifierArray[1]}|${nestedModifierArray[2]}`);
      }
      if (!modifierData.includes(nestedModifierArray[0])) {
        pushModifierToItem(nestedModifierArray[0]);
      }
      setPrevModifier(modifierData);
    } else if (isDelete) {
      pushModifierToItem(updatedModifierData);
      setPrevModifier([]);
    } else {
      pushModifierToCount(tempModifier);
      setPrevModifier(tempModifier);
    }
    nestedModifierArray.pop();
    setNestedModifierArray(nestedModifierArray);
    setAddBoolean(false);
    if (nestedModifierArray.length === 0) {
      const modifierList = menuItemsHashTable[props.match.params.menuItemId].modifierGroupLinks.map((item) => ({
        ...item,
        ...modifierGroupsHashTable[item.modifierGroupId]
      }));
      pushModifiersGroupData(modifierList, 'isNested');
      toggleNestedModifierFlag(false);
      setIsSubNestModifier(false);
    } else {
      const menuItemId = nestedModifierArray[nestedModifierArray.length - 1].split('|').filter((el) => {
        return el !== '';
      }).slice(-1)[0].split('-')[0];
      const modifierList = modifiersHashTable[menuItemId].modifierGroupLinks.map((item) => ({
        ...item,
        ...modifierGroupsHashTable[item.modifierGroupId]
      }));
      pushModifiersGroupData(modifierList, 'isNested');
    }
  };
  const onSlideChange = (path, remove) => {
    if (remove) {
      updateModifierToItemPromise(path.split('|')[0], null);
    } else {
      updateModifierToItemPromise(path.split('|')[0], path).then(() => {
        if (!modifierData.includes(path.split('|')[0])) {
          pushModifierToItem(path.split('|')[0]);
        }
      });
    }
  };

  const removeNestedModifier = () => {
    const modifierDatatocheck = filter(modifierData, (d) => !d?.startsWith(`${getPath(nestedModifierArray)}`));
    if (modifierDatatocheck[0]?.includes('|')) {
      const newEle = modifierDatatocheck[0].split('|')[0];
      const newEle1 = newEle.split('-')[1];
      if (modifierGroupsHashTable[newEle1]?.isWeight === false){
        const modifierDataToPush = filter(modifierData, (d) => !d?.startsWith(`${getPath(nestedModifierArray)}`));
        onNestedBack(false, true, modifierDataToPush);
        return;
      }
    } else if (modifierDatatocheck.length > 0) {
      const newEle1 = modifierDatatocheck[0].split('-')[1];
      if (modifierGroupsHashTable[newEle1]?.isWeight === false){
        const modifierDataToPush = filter(modifierData, (d) => !d?.startsWith(`${getPath(nestedModifierArray)}`));
        onNestedBack(false, true, modifierDataToPush);
        return;
      }
    }
    
    let foundErr = false;
    let element = '';
    if (nestedModifierArray?.length > 1) {
    for (let index = 0; index < nestedModifierArray.length; index += 1) {
      element = nestedModifierArray[index];
      if (element.includes('|')) {
        const newEle = element.split('|')[0];
        const newEle1 = newEle.split('-')[1];
        if (modifierGroupsHashTable[newEle1]?.modifierLinks[0]?.weight > 0) {
          foundErr = true;
        }
      }
    }
    }
    if (foundErr) {
      const nestedFound = nestedModifierArray.filter((con) => con === element);
      if (nestedFound.length > 0) {
        const nesModArray = [];
        nesModArray.push(nestedFound[0]);
        setNestedModifierArray(nesModArray);
        const modifierDataToPush = filter(modifierData, (d) => !d?.startsWith(`${getPath(nesModArray)}`));
        onNestedBack(false, true, modifierDataToPush, nesModArray);
        return;
      }
      const modifierDataToPush = filter(modifierData, (d) => !d?.startsWith(`${getPath(nestedModifierArray)}`));
      onNestedBack(false, true, modifierDataToPush);
      return;
    }
    const modifierDataToPush = filter(modifierData, (d) => !d?.startsWith(`${getPath(nestedModifierArray)}`));
    onNestedBack(false, true, modifierDataToPush);
  };
  const pushNestedModifierCounter = (data, isInc) => {
    if (isInc) {
      pushModifierToCount(data, true);
    } else {
      pushModifierToCount(data, false);
    }
  };

  const handleGlobalModFunction = (modifierGroup, modifier) => {
    const selectedModifierPath = modifier && modifierGroup ? `${modifier}-${modifierGroup}` : '';
    setSelectedModifierPath(selectedModifierPath);
  };

  const rendermodifierData = renderModifierData(showEdit, modifierGroupsHashTable, modifierLevelData, modifiersHashTable, onClickModifier, onClickAddModifier, modifierData, nestedModifierArray, themeStyle, onClickModifierCounter, onClickNegitiveModifierCounter, setPrevModifier, itemInfo, onSlideChange, pushNestedModifierCounter, activeMenuItemId, menuItemsHashTable, isNestedModifier, updateCollapsedModifierArray, collapsedModifierArray, isOrderAnother, props.match.params.menuItemId, auth, menusList, menuIndex, modifierNote, handleNote, handleGlobalModFunction);
  return (
    <div id="modifiersContainer" className="h-100">
      {props.loading && <Loader />}
      <div className={cn('col-12 p-0 overflowY', isNestedModifier ? 'h-90' : 'h-100')}>
        {isNestedModifier && (
          <div className="text-primary od-text-primary fs-18 fw-700 text-center py-1" ref={subModRef}>
            {getObjectValue(() => modifiersHashTable[nestedModifierArray[0].split('-')[0]].name, '')}
          </div>
        )}
        {rendermodifierData}
      </div>
      {(isNestedModifier && !props.loading) && (
        <div className="col-12 fs-12 od-text-secondary">
          {getObjectValue(() => modifiersHashTable[nestedModifierArray[0].split('-')[0]].disclaimer, '')}
        </div>
      )}
      {(isNestedModifier && !props.loading) && (
        <div
          className={cn(['kiosk'].includes(flowType()) ? `w-100 d-flex align-items-center ${style.btnFix}` : 'w-75 d-flex align-items-center', 'col-12 p-0 h-10 od-app-background-color background-primary', !['kiosk'].includes(flowType()) && (userInfo?.flipView ? style.fixedBottomRight : style.fixedBottomLeft))}
        >
          <div className="d-flex w-100 justify-content-center align-items-end">
            <div className="col-6">
              <button className={cn('btn btn-secondary od-btn-secondary w-100', ['kiosk'].includes(flowType()) ? 'btn100' : 'btn50')} type="button" onClick={() => { editModifiers(null); setScroll(true); removeNestedModifier(); }}><div className="fs-18">{LABEL().REFILL_REMOVE}</div></button>
            </div>
            <div className="col-6">
              <button className={cn('btn btn-primary btn-ripple od-btn-primary w-100 px-4', ['kiosk'].includes(flowType()) ? 'btn100' : 'btn50')} type="button" onClick={() => { editModifiers(null); setScroll(true); onNestedBack(true); }}><div className="fs-18">{LABEL().DONE}</div></button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Redux part

const mapStateToProps = ({
  orders, header, theme, oauth
}) => ({
  userInfo: oauth.loggedInUserData,
  loading: orders.loading,
  themeStyle: theme.styles,
  modifierLevelData: orders.modifierLevelData,
  modifiersHashTable: orders.modifiersHashTable,
  modifierData: orders.modifierData,
  modifierGroupsHashTable: orders.modifierGroupsHashTable,
  isNestedModifier: orders.isNestedModifier,
  menuItemsHashTable: orders.menuItemsHashTable,
  cancelOnPage: header.cancelOnPage,
  menusList: orders.menusList,
  menuIndex: orders.menuIndex,
  activeMenuItemId: Number(urlSearchParams('menuId')) || 0,
  collapsedModifierArray: orders.collapsedModifierArray.length > 0 ? [] : orders.collapsedModifierArray,
  functionModifierId: orders.functionModifierId,
  globalModEnabled: orders.globalModEnabled,
  modifierEditData: orders.modifierEditData,
  modfierEdit: orders.modfierEdit
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  pushModifierToItem,
  toggleNestedModifierFlag,
  pushModifiersGroupData,
  pushNestedModifierToItem,
  setNotification,
  toggleCancelButtonSamePage,
  pushModifierToCount,
  updateHeaderData,
  removeModifiers,
  updateModifierToItemPromise,
  appendModifiersToList,
  updateCollapsedModifierArray,
  setFunctionModifierId,
  setGlobalModStatus,
  setSelectedModifierPath,
  editModifiers,
}, dispatch);
const MemoModifier = memo(Modifier)
export default connect(mapStateToProps, mapDispatchToProps)(MemoModifier);
